import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';

export interface TripleConfirmModalData {
  title?: string;
  message?: string;
  subMessage?: string;
  firstText?: string;
  secondText?: string;
  thirdText?: string;
  buttonStyles?: { first?: string; second?: string; third?: string };
  revertButtons?: boolean;
}

@Component({
  selector: 'wfs-new-triple-confirm-modal',
  templateUrl: './new-triple-confirm-modal.component.html',
  styleUrls: ['./new-triple-confirm-modal.component.scss'],
  imports: [CommonModule, FormButtonComponent, MatDialogModule],
  encapsulation: ViewEncapsulation.None // makes styling applicable globally but only for this component
})
export class NewTripleConfirmModalComponent {
  readonly data = inject<TripleConfirmModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  triggerEvent(value: number): void {
    this.#dialogRef.close(value);
  }
}
